import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function t(e, n) {
  var i = _objectSpread({}, e);

  for (var _o in n) {
    "object" != typeof e[_o] || null === e[_o] || Array.isArray(e[_o]) ? void 0 !== n[_o] && (i[_o] = n[_o]) : i[_o] = t(e[_o], n[_o]);
  }

  return i;
}

var e = {
  mobile: {
    disabled_features: ["left_toolbar", "header_widget", "timeframes_toolbar", "edit_buttons_in_legend", "context_menus", "control_bar", "border_around_the_chart"],
    enabled_features: []
  }
},
    n = {
  width: 800,
  height: 500,
  interval: "1D",
  timezone: "Etc/UTC",
  container: "",
  library_path: "",
  locale: "en",
  widgetbar: {
    details: !1,
    watchlist: !1,
    watchlist_settings: {
      default_symbols: []
    }
  },
  overrides: {
    "mainSeriesProperties.showCountdown": !1
  },
  studies_overrides: {},
  trading_customization: {
    position: {},
    order: {}
  },
  brokerConfig: {
    configFlags: {}
  },
  fullscreen: !1,
  autosize: !1,
  disabled_features: [],
  enabled_features: [],
  debug: !1,
  logo: {},
  time_frames: [{
    text: "5y",
    resolution: "1W"
  }, {
    text: "1y",
    resolution: "1W"
  }, {
    text: "6m",
    resolution: "120"
  }, {
    text: "3m",
    resolution: "60"
  }, {
    text: "1m",
    resolution: "30"
  }, {
    text: "5d",
    resolution: "5"
  }, {
    text: "1d",
    resolution: "1"
  }],
  client_id: "0",
  user_id: "0",
  charts_storage_api_version: "1.0",
  favorites: {
    intervals: [],
    chartTypes: []
  }
};
var i = !1;

function o(t) {
  var e;
  var n = /\.woff(\d*)/.exec(t);
  return "<link rel=\"preload\" href=\"".concat(t, "\" as=\"font\" type=\"font/woff").concat(null !== (e = null == n ? void 0 : n[1]) && void 0 !== e ? e : "2", "\" crossorigin=\"anonymous\"/>");
}

function s(t, e) {
  var n = new URL("".concat(t || ""), location.href).href,
      i = JSON.parse('["bundles/runtime.6b7a1146863d7196d6d3.js","bundles/5386.eb112967859403067d3d.css","bundles/5386.eb112967859403067d3d.rtl.css","bundles/1857.10c97feeb46d934b8a25.js","bundles/library.a70ecf079f22e76a3ae6.js","bundles/b1a63a011fd92dfb93db6db243bb036c.woff2","bundles/40f9a03d174178efb12303caa9bc7cd8.woff2","bundles/3293616ec0c605c7c2db25829a0a509e.woff"]'),
      s = JSON.parse('[{"iso":"ar","dir":"rtl","language":"ar"},{"iso":"pt","dir":"ltr","language":"pt"},{"iso":"cs","dir":"ltr","language":"cs"},{"iso":"de","dir":"ltr","language":"de"},{"iso":"en","dir":"ltr","language":"en"},{"iso":"es","dir":"ltr","language":"es"},{"iso":"fa","dir":"rtl","language":"fa"},{"iso":"fr","dir":"ltr","language":"fr"},{"iso":"he","dir":"rtl","language":"he_IL"},{"iso":"hu","dir":"ltr","language":"hu_HU"},{"iso":"id","dir":"ltr","language":"id_ID"},{"iso":"en","dir":"ltr","language":"en"},{"iso":"it","dir":"ltr","language":"it"},{"iso":"ja","dir":"ltr","language":"ja"},{"iso":"ko","dir":"ltr","language":"ko"},{"iso":"ms","dir":"ltr","language":"ms_MY"},{"iso":"pl","dir":"ltr","language":"pl"},{"iso":"ru","dir":"ltr","language":"ru"},{"iso":"sv","dir":"ltr","language":"sv"},{"iso":"th","dir":"ltr","language":"th"},{"iso":"tr","dir":"ltr","language":"tr"},{"iso":"vi","dir":"ltr","language":"vi"},{"iso":"zh-Hans","dir":"ltr","language":"zh"},{"iso":"zh-Hant","dir":"ltr","language":"zh_TW"},{"iso":"el","dir":"ltr","language":"el"},{"iso":"nl","dir":"ltr","language":"nl_NL"},{"iso":"ro","dir":"ltr","language":"ro"}]'),
      r = encodeURIComponent(e),
      a = s.find(function (t) {
    return t.language === r;
  }),
      d = "lang=\"".concat(a.iso, "\" dir=\"").concat(a.dir, "\""),
      l = "\n".concat(function (t, e) {
    if (void 0 === t) return "";
    var n = [],
        i = [],
        s = [],
        r = /\.css$/i,
        a = /\.rtl\.css$/i;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _d = _step.value;
        _d.endsWith(".js") ? i.push("<script defer crossorigin=\"anonymous\" src=\"".concat(_d, "\"></script>")) : r.test(_d) && e === a.test(_d) ? s.push("<link type=\"text/css\" href=\"".concat(_d, "\" rel=\"stylesheet\"/>")) : /\.woff\d*/.test(_d) && n.push(o(_d));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return [].concat(n, i, s).join("\n");
  }(i, "rtl" === a.dir), "\n");
  return "<!DOCTYPE html><html ".concat((h = {
    bundles: l,
    localeLanguage: r,
    htmlAttrs: d,
    libraryPath: n
  }).htmlAttrs, "><head><base href=\"").concat(h.libraryPath, "\"><meta charset=\"utf-8\"><script>window===window.parent&&(location.href=\"about:blank\")</script><script src=\"").concat(h.localeLanguage, "-tv-locale.e012cb8f.js\" crossorigin=\"anonymous\"></script> ").concat(h.bundles, " </head><body class=\"chart-page unselectable on-widget\"><div class=\"loading-indicator\" id=\"loading-indicator\"></div><script>var JSServer={},__initialEnabledFeaturesets=[\"charting_library\"]</script><script>(function() {\n\t\twindow.urlParams = (function () {\n\t\t\tvar match,\n\t\t\t\tpl\t = /\\+/g,  // Regex for replacing addition symbol with a space\n\t\t\t\tsearch = /([^&=]+)=?([^&]*)/g,\n\t\t\t\tdecode = function (s) { return decodeURIComponent(s.replace(pl, ' ')).replace(/<\\/?[^>]+(>|$)/g, ''); },\n\t\t\t\tquery = function() {\n\t\t\t\t\t// not using location.hash due to a bug in FF http://stackoverflow.com/questions/7338373/window-location-hash-issue-in-firefox\n\t\t\t\t\tvar url = location.href;\n\t\t\t\t\tvar idx = url.indexOf('#');\n\t\t\t\t\tif (idx >= 0) {\n\t\t\t\t\t\treturn url.substring(idx + 1);\n\t\t\t\t\t} else if (frameElement && frameElement.dataset.widgetOptions) {\n\t\t\t\t\t\t// fallback for safari 14 which strips hash from blob urls\n\t\t\t\t\t\treturn frameElement.dataset.widgetOptions;\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthrow \"Unexpected use of this page\";\n\t\t\t\t\t}\n\t\t\t\t}(),\n\t\t\t\tresult = {};\n\n\t\t\twhile (match = search.exec(query)) {\n\t\t\t\tresult[decode(match[1])] = decode(match[2]);\n\t\t\t}\n\n\t\t\tvar additionalSettingsObject = window.parent[result.uid];\n\n\t\t\tvar customObjectNames = ['datafeed', 'customFormatters', 'brokerFactory', 'save_load_adapter', 'customTranslateFunction', 'contextMenu'];\n\n\t\t\tfor (var p in additionalSettingsObject) {\n\t\t\t\tif (customObjectNames.indexOf(p) === -1) {\n\t\t\t\t\tresult[p] = JSON.stringify(additionalSettingsObject[p]);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\treturn result;\n\t\t})();\n\n\t\twindow.locale = urlParams.locale;\n\t\twindow.language = urlParams.locale; // a very big attention needed here\n\t\twindow.customTranslateFunction = window.parent[urlParams.uid].customTranslateFunction;\n\n\t\twindow.addCustomCSSFile = function(href) {\n\t\t\tvar link = document.createElement('link');\n\t\t\tlink.setAttribute('type', 'text/css');\n\t\t\tlink.setAttribute('rel', 'stylesheet');\n\t\t\tlink.setAttribute('href', href);\n\t\t\tlink.setAttribute('cross-origin', 'anonymous');\n\t\t\t\n\t\t\twindow.loadedCustomCss = new Promise((resolve) => {\n\t\t\t\tlink.onload = resolve;\n\t\t\t\tlink.onerror = resolve;\n\t\t\t});\n\t\t\tdocument.body.appendChild(link);\n\t\t};\n\n\t\twindow.loadedCustomCss = Promise.resolve();\n\t\tif (!!urlParams.customCSS) {\n\t\t\twindow.addCustomCSSFile(urlParams.customCSS);\n\t\t}\n\n\t\tvar loadingScreenParams = {};\n\n\t\tif (typeof urlParams.loading_screen === 'string') {\n\t\t\ttry {\n\t\t\t\tloadingScreenParams = JSON.parse(urlParams.loading_screen);\n\t\t\t} catch(e) {}\n\t\t}\n\n\t\tvar loadingIndicatorElement = document.getElementById('loading-indicator');\n\n\t\tif (loadingScreenParams.backgroundColor) {\n\t\t\tloadingIndicatorElement.style = 'background-color: ' + loadingScreenParams.backgroundColor;\n\t\t}\n\n\t\t!function(){\"use strict\";!function(t,e){void 0===e&&(e={});var n=e.insertAt;if(t&&\"undefined\"!=typeof document){var o=document.head||document.getElementsByTagName(\"head\")[0],i=document.createElement(\"style\");i.type=\"text/css\",\"top\"===n&&o.firstChild?o.insertBefore(i,o.firstChild):o.appendChild(i),i.styleSheet?i.styleSheet.cssText=t:i.appendChild(document.createTextNode(t))}}(\":global(.tv-spinner) {display: none;position: absolute;width: 1em;height: 1em;top: calc(50% - 0.5em);left: calc(50% - 0.5em);margin: 0 auto;border: 4px solid rgba(135, 151, 165, 0.2);border-radius: 50%;border-top-color: var(--tv-spinner-color, #2962FF);border-left-color: var(--tv-spinner-color, #2962FF);animation: tv-spinner__container-rotate 0.9s linear infinite;}:global(.tv-spinner)--shown {display: block;}:global(.tv-spinner)--size_xsmall {font-size: 14px;border-width: 2px;}:global(.tv-spinner)--size_small {font-size: 20px;border-width: 2px;}:global(.tv-spinner)--size_medium {font-size: 28px;border-width: 3px;}:global(.tv-spinner)--size_large {font-size: 56px;border-width: 4px;}  @keyframes tv-spinner__container-rotate {to {transform: rotate(360deg);}}\");var t,e=new WeakMap;!function(t){t[t.Element=1]=\"Element\",t[t.Document=9]=\"Document\"}(t||(t={}));var n={mini:\"xsmall\",xsmall:\"xsmall\",small:\"small\",medium:\"medium\",large:\"large\"};var o,i,r,s,l,a=(void 0===l&&(l=\"\"),o='<div class=\"tv-spinner '.concat(l,'\" role=\"progressbar\"></div>'),r=function(n,o){var i,r;return i=null==o?document.documentElement:o.nodeType===t.Document?o.documentElement:o,e&&(r=e.get(i)),r||((r=i.ownerDocument.createRange()).selectNodeContents(i),e&&e.set(i,r)),r.createContextualFragment(n)}(o,i),null!==(s=r.firstElementChild)&&r.removeChild(s),s),c=function(){function t(t){this._shown=!1,this._el=a.cloneNode(!0),this.setSize(n[t||\"large\"])}return t.prototype.spin=function(t){return this._el.classList.add(\"tv-spinner--shown\"),void 0===this._container&&(this._container=t,void 0!==t&&t.appendChild(this._el)),this._shown=!0,this},t.prototype.stop=function(t){return t&&void 0!==this._container&&this._container.removeChild(this._el),this._el.classList.remove(\"tv-spinner--shown\"),this._shown=!1,this},t.prototype.setStyle=function(t){var e=this;return Object.keys(t).forEach((function(n){var o=t[n];void 0!==o&&e._el.style.setProperty(n,o)})),this},t.prototype.style=function(){return this._el.style},t.prototype.setSize=function(t){var e=void 0!==t?\"tv-spinner--size_\".concat(t):\"\";return this._el.className=\"tv-spinner \".concat(e,\" \").concat(this._shown?\"tv-spinner--shown\":\"\"),this},t.prototype.getEl=function(){return this._el},t.prototype.destroy=function(){this.stop(),delete this._el,delete this._container},t}();window.Spinner=c}();\n\n\n\t\tvar spinnerColor = (loadingScreenParams.foregroundColor) ? loadingScreenParams.foregroundColor : undefined;\n\n\t\tvar loadingSpinner = new Spinner('large').setStyle({\n\t\t\t'--tv-spinner-color': spinnerColor,\n\t\t\tzIndex: String(2e9),\n\t\t});\n\t\tloadingSpinner.getEl().classList.add('spinner');\n\t\tloadingSpinner.spin(loadingIndicatorElement);\n\t})();</script></body></html>");
  var h;
}

function r() {
  return "CL v23.038 (internal id e012cb8f @ 2022-12-20T06:06:49.573Z)";
}

var a =
/*#__PURE__*/
function () {
  function a(o) {
    _classCallCheck(this, a);

    var s;
    if (this._id = "tradingview_".concat((1048576 * (1 + Math.random()) | 0).toString(16).substring(1)), this._ready = !1, this._readyHandlers = [], this._onWindowResize = this._autoResizeChart.bind(this), !o.datafeed) throw new Error("Datafeed is not defined");

    if ((null === (s = o.overrides) || void 0 === s ? void 0 : s["mainSeriesProperties.priceAxisProperties.lockScale"]) && (console.warn("mainSeriesProperties.priceAxisProperties.lockScale can not be set to true within the widget constructor"), delete o.overrides["mainSeriesProperties.priceAxisProperties.lockScale"]), this._options = t(n, o), o.preset) {
      var _t = e[o.preset];
      _t ? (void 0 !== this._options.disabled_features ? this._options.disabled_features = this._options.disabled_features.concat(_t.disabled_features) : this._options.disabled_features = _t.disabled_features, void 0 !== this._options.enabled_features ? this._options.enabled_features = this._options.enabled_features.concat(_t.enabled_features) : this._options.enabled_features = _t.enabled_features) : console.warn("Unknown preset: `" + o.preset + "`");
    }

    "Dark" === this._options.theme && void 0 === this._options.loading_screen && (this._options.loading_screen = {
      backgroundColor: "#131722"
    }), this._options.debug && (i || (i = !0, console.log("Using CL v23.038 (internal id e012cb8f @ 2022-12-20T06:06:49.573Z)"))), this._create();
  }

  _createClass(a, [{
    key: "setDebugMode",
    value: function setDebugMode(t) {
      this._innerAPI().setDebugMode(t);
    }
  }, {
    key: "onChartReady",
    value: function onChartReady(t) {
      this._ready ? t.call(this) : this._readyHandlers.push(t);
    }
  }, {
    key: "headerReady",
    value: function headerReady() {
      var _this = this;

      return this._innerWindowLoaded.then(function () {
        return _this._innerWindow().headerReady();
      });
    }
  }, {
    key: "onGrayedObjectClicked",
    value: function onGrayedObjectClicked(t) {
      this._doWhenInnerApiLoaded(function (e) {
        e.onGrayedObjectClicked(t);
      });
    }
  }, {
    key: "onShortcut",
    value: function onShortcut(t, e) {
      this._doWhenInnerWindowLoaded(function (n) {
        n.createShortcutAction(t, e);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(t, e) {
      this._doWhenInnerApiLoaded(function (n) {
        n.subscribe(t, e);
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(t, e) {
      this._doWhenInnerApiLoaded(function (n) {
        n.unsubscribe(t, e);
      });
    }
  }, {
    key: "chart",
    value: function chart(t) {
      return this._innerAPI().chart(t);
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this._options.locale;
    }
  }, {
    key: "setSymbol",
    value: function setSymbol(t, e, n) {
      this._innerAPI().changeSymbol(t, e, n);
    }
  }, {
    key: "remove",
    value: function remove() {
      window.removeEventListener("resize", this._onWindowResize), this._readyHandlers.splice(0, this._readyHandlers.length), delete window[this._id], this._iFrame.parentNode && this._iFrame.parentNode.removeChild(this._iFrame);
    }
  }, {
    key: "closePopupsAndDialogs",
    value: function closePopupsAndDialogs() {
      this._doWhenInnerApiLoaded(function (t) {
        t.closePopupsAndDialogs();
      });
    }
  }, {
    key: "selectLineTool",
    value: function selectLineTool(t, e) {
      this._innerAPI().selectLineTool(t, e);
    }
  }, {
    key: "selectedLineTool",
    value: function selectedLineTool() {
      return this._innerAPI().selectedLineTool();
    }
  }, {
    key: "save",
    value: function save(t) {
      this._innerAPI().saveChart(t);
    }
  }, {
    key: "load",
    value: function load(t, e) {
      this._innerAPI().loadChart({
        json: t,
        extendedData: e
      });
    }
  }, {
    key: "getSavedCharts",
    value: function getSavedCharts(t) {
      this._innerAPI().getSavedCharts(t);
    }
  }, {
    key: "loadChartFromServer",
    value: function loadChartFromServer(t) {
      this._innerAPI().loadChartFromServer(t);
    }
  }, {
    key: "saveChartToServer",
    value: function saveChartToServer(t, e, n) {
      this._innerAPI().saveChartToServer(t, e, n);
    }
  }, {
    key: "removeChartFromServer",
    value: function removeChartFromServer(t, e) {
      this._innerAPI().removeChartFromServer(t, e);
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(t) {
      this._doWhenInnerApiLoaded(function (e) {
        e.onContextMenu(t);
      });
    }
  }, {
    key: "createButton",
    value: function createButton(t) {
      return this._innerWindow().createButton(t);
    }
  }, {
    key: "createDropdown",
    value: function createDropdown(t) {
      return this._innerWindow().createDropdown(t);
    }
  }, {
    key: "showNoticeDialog",
    value: function showNoticeDialog(t) {
      this._doWhenInnerApiLoaded(function (e) {
        e.showNoticeDialog(t);
      });
    }
  }, {
    key: "showConfirmDialog",
    value: function showConfirmDialog(t) {
      this._doWhenInnerApiLoaded(function (e) {
        e.showConfirmDialog(t);
      });
    }
  }, {
    key: "showLoadChartDialog",
    value: function showLoadChartDialog() {
      this._innerAPI().showLoadChartDialog();
    }
  }, {
    key: "showSaveAsChartDialog",
    value: function showSaveAsChartDialog() {
      this._innerAPI().showSaveAsChartDialog();
    }
  }, {
    key: "symbolInterval",
    value: function symbolInterval() {
      return this._innerAPI().getSymbolInterval();
    }
  }, {
    key: "mainSeriesPriceFormatter",
    value: function mainSeriesPriceFormatter() {
      return this._innerAPI().mainSeriesPriceFormatter();
    }
  }, {
    key: "getIntervals",
    value: function getIntervals() {
      return this._innerAPI().getIntervals();
    }
  }, {
    key: "getStudiesList",
    value: function getStudiesList() {
      return this._innerAPI().getStudiesList();
    }
  }, {
    key: "getStudyInputs",
    value: function getStudyInputs(t) {
      return this._innerAPI().getStudyInputs(t);
    }
  }, {
    key: "getStudyStyles",
    value: function getStudyStyles(t) {
      return this._innerAPI().getStudyStyles(t);
    }
  }, {
    key: "addCustomCSSFile",
    value: function addCustomCSSFile(t) {
      this._innerWindow().addCustomCSSFile(t);
    }
  }, {
    key: "applyOverrides",
    value: function applyOverrides(e) {
      this._options = t(this._options, {
        overrides: e
      }), this._doWhenInnerWindowLoaded(function (t) {
        t.applyOverrides(e);
      });
    }
  }, {
    key: "applyStudiesOverrides",
    value: function applyStudiesOverrides(t) {
      this._doWhenInnerWindowLoaded(function (e) {
        e.applyStudiesOverrides(t);
      });
    }
  }, {
    key: "watchList",
    value: function watchList() {
      return this._innerAPI().watchlist();
    }
  }, {
    key: "news",
    value: function news() {
      return this._innerAPI().news();
    }
  }, {
    key: "widgetbar",
    value: function widgetbar() {
      return this._innerAPI().widgetbar();
    }
  }, {
    key: "activeChart",
    value: function activeChart() {
      return this._innerAPI().activeChart();
    }
  }, {
    key: "chartsCount",
    value: function chartsCount() {
      return this._innerAPI().chartsCount();
    }
  }, {
    key: "layout",
    value: function layout() {
      return this._innerAPI().layout();
    }
  }, {
    key: "setLayout",
    value: function setLayout(t) {
      this._innerAPI().setLayout(t);
    }
  }, {
    key: "layoutName",
    value: function layoutName() {
      return this._innerAPI().layoutName();
    }
  }, {
    key: "changeTheme",
    value: function changeTheme(t, e) {
      return this._innerWindow().changeTheme(t, e);
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      return this._innerWindow().getTheme();
    }
  }, {
    key: "takeScreenshot",
    value: function takeScreenshot() {
      this._doWhenInnerApiLoaded(function (t) {
        t.takeScreenshot();
      });
    }
  }, {
    key: "lockAllDrawingTools",
    value: function lockAllDrawingTools() {
      return this._innerAPI().lockAllDrawingTools();
    }
  }, {
    key: "hideAllDrawingTools",
    value: function hideAllDrawingTools() {
      return this._innerAPI().hideAllDrawingTools();
    }
  }, {
    key: "drawOnAllCharts",
    value: function drawOnAllCharts(t) {
      this._innerAPI().drawOnAllCharts(t);
    }
  }, {
    key: "magnetEnabled",
    value: function magnetEnabled() {
      return this._innerAPI().magnetEnabled();
    }
  }, {
    key: "magnetMode",
    value: function magnetMode() {
      return this._innerAPI().magnetMode();
    }
  }, {
    key: "undoRedoState",
    value: function undoRedoState() {
      return this._innerAPI().undoRedoState();
    }
  }, {
    key: "setIntervalLinkingEnabled",
    value: function setIntervalLinkingEnabled(t) {
      this._innerAPI().setIntervalLinkingEnabled(t);
    }
  }, {
    key: "setTimeFrame",
    value: function setTimeFrame(t) {
      this._innerAPI().setTimeFrame(t);
    }
  }, {
    key: "symbolSync",
    value: function symbolSync() {
      return this._innerAPI().symbolSync();
    }
  }, {
    key: "intervalSync",
    value: function intervalSync() {
      return this._innerAPI().intervalSync();
    }
  }, {
    key: "crosshairSync",
    value: function crosshairSync() {
      return this._innerAPI().crosshairSync();
    }
  }, {
    key: "timeSync",
    value: function timeSync() {
      return this._innerAPI().timeSync();
    }
  }, {
    key: "getAllFeatures",
    value: function getAllFeatures() {
      return this._innerWindow().getAllFeatures();
    }
  }, {
    key: "clearUndoHistory",
    value: function clearUndoHistory() {
      return this._innerAPI().clearUndoHistory();
    }
  }, {
    key: "undo",
    value: function undo() {
      return this._innerAPI().undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      return this._innerAPI().redo();
    }
  }, {
    key: "startFullscreen",
    value: function startFullscreen() {
      this._innerAPI().startFullscreen();
    }
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      this._innerAPI().exitFullscreen();
    }
  }, {
    key: "takeClientScreenshot",
    value: function takeClientScreenshot(t) {
      return this._innerAPI().takeClientScreenshot(t);
    }
  }, {
    key: "navigationButtonsVisibility",
    value: function navigationButtonsVisibility() {
      return this._innerWindow().getNavigationButtonsVisibility();
    }
  }, {
    key: "paneButtonsVisibility",
    value: function paneButtonsVisibility() {
      return this._innerWindow().getPaneButtonsVisibility();
    }
  }, {
    key: "dateFormat",
    value: function dateFormat() {
      return this._innerWindow().getDateFormat();
    }
  }, {
    key: "supportedChartTypes",
    value: function supportedChartTypes() {
      return this._innerAPI().supportedChartTypes();
    }
  }, {
    key: "_innerAPI",
    value: function _innerAPI() {
      return this._innerWindow().tradingViewApi;
    }
  }, {
    key: "_innerWindow",
    value: function _innerWindow() {
      return this._iFrame.contentWindow;
    }
  }, {
    key: "_doWhenInnerWindowLoaded",
    value: function _doWhenInnerWindowLoaded(t) {
      var _this2 = this;

      this._ready ? t(this._innerWindow()) : this._innerWindowLoaded.then(function () {
        t(_this2._innerWindow());
      });
    }
  }, {
    key: "_doWhenInnerApiLoaded",
    value: function _doWhenInnerApiLoaded(t) {
      var _this3 = this;

      this._doWhenInnerWindowLoaded(function (e) {
        e.doWhenApiIsReady(function () {
          return t(_this3._innerAPI());
        });
      });
    }
  }, {
    key: "_autoResizeChart",
    value: function _autoResizeChart() {
      this._options.fullscreen && (this._iFrame.style.height = window.innerHeight + "px");
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this4 = this;

      var t = this._render();

      this._options.container_id && console.warn("`container_id` is now deprecated. Please use `container` instead to either still pass a string or an `HTMLElement`.");
      var e = this._options.container_id || this._options.container,
          n = "string" == typeof e ? document.getElementById(e) : e;
      if (null === n) throw new Error("There is no such element - #".concat(this._options.container));
      n.innerHTML = t, this._iFrame = n.querySelector("#".concat(this._id));
      var i = this._iFrame;
      (this._options.autosize || this._options.fullscreen) && (i.style.width = "100%", this._options.fullscreen || (i.style.height = "100%")), window.addEventListener("resize", this._onWindowResize), this._onWindowResize(), this._innerWindowLoaded = new Promise(function (t) {
        var e = function e() {
          i.removeEventListener("load", e, !1), t();
        };

        i.addEventListener("load", e, !1);
      }), this._innerWindowLoaded.then(function () {
        _this4._innerWindow().widgetReady(function () {
          _this4._ready = !0;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _this4._readyHandlers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _t2 = _step2.value;

              try {
                _t2.call(_this4);
              } catch (t) {
                console.error(t);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this4._innerWindow().initializationFinished();
        });
      });
    }
  }, {
    key: "_render",
    value: function _render() {
      var t = window;
      if (t[this._id] = {
        datafeed: this._options.datafeed,
        customFormatters: this._options.custom_formatters || this._options.customFormatters,
        brokerFactory: this._options.broker_factory || this._options.brokerFactory,
        overrides: this._options.overrides,
        studiesOverrides: this._options.studies_overrides,
        tradingCustomization: this._options.trading_customization,
        disabledFeatures: this._options.disabled_features,
        enabledFeatures: this._options.enabled_features,
        brokerConfig: this._options.broker_config || this._options.brokerConfig,
        restConfig: this._options.restConfig,
        favorites: this._options.favorites,
        logo: this._options.logo,
        numeric_formatting: this._options.numeric_formatting,
        rss_news_feed: this._options.rss_news_feed,
        newsProvider: this._options.news_provider,
        loadLastChart: this._options.load_last_chart,
        saveLoadAdapter: this._options.save_load_adapter,
        loading_screen: this._options.loading_screen,
        settingsAdapter: this._options.settings_adapter,
        getCustomIndicators: this._options.custom_indicators_getter,
        additionalSymbolInfoFields: this._options.additional_symbol_info_fields,
        headerWidgetButtonsMode: this._options.header_widget_buttons_mode,
        customTranslateFunction: this._options.custom_translate_function,
        symbolSearchComplete: this._options.symbol_search_complete,
        contextMenu: this._options.context_menu,
        settingsOverrides: this._options.settings_overrides,
        timeframe: this._options.timeframe
      }, this._options.saved_data) t[this._id].chartContent = {
        json: this._options.saved_data
      }, this._options.saved_data_meta_info && (t[this._id].chartContentExtendedData = this._options.saved_data_meta_info);else if (!this._options.load_last_chart && !this._options.symbol) throw new Error("Symbol is not defined: either 'symbol' or 'load_last_chart' option must be set");
      this._options.library_path && !this._options.library_path.endsWith("/") && console.warn("library_path option should contain a trailing forward slash");
      var e = s(this._options.library_path || "", this._options.locale),
          n = new Blob([e], {
        type: "text/html"
      }),
          i = URL.createObjectURL(n),
          o = new URL(i),
          r = "symbol=" + encodeURIComponent(this._options.symbol || "") + "&interval=" + encodeURIComponent(this._options.interval) + (this._options.toolbar_bg ? "&toolbarbg=" + encodeURIComponent(this._options.toolbar_bg.replace("#", "")) : "") + (this._options.studies_access ? "&studiesAccess=" + encodeURIComponent(JSON.stringify(this._options.studies_access)) : "") + "&widgetbar=" + encodeURIComponent(JSON.stringify(this._options.widgetbar)) + (this._options.drawings_access ? "&drawingsAccess=" + encodeURIComponent(JSON.stringify(this._options.drawings_access)) : "") + "&timeFrames=" + encodeURIComponent(JSON.stringify(this._options.time_frames)) + "&locale=" + encodeURIComponent(this._options.locale) + "&uid=" + encodeURIComponent(this._id) + "&clientId=" + encodeURIComponent(String(this._options.client_id)) + "&userId=" + encodeURIComponent(String(this._options.user_id)) + (this._options.charts_storage_url ? "&chartsStorageUrl=" + encodeURIComponent(this._options.charts_storage_url) : "") + (this._options.charts_storage_api_version ? "&chartsStorageVer=" + encodeURIComponent(this._options.charts_storage_api_version) : "") + (this._options.custom_css_url ? "&customCSS=" + encodeURIComponent(this._options.custom_css_url) : "") + (this._options.custom_font_family ? "&customFontFamily=" + encodeURIComponent(this._options.custom_font_family) : "") + (this._options.auto_save_delay ? "&autoSaveDelay=" + encodeURIComponent(String(this._options.auto_save_delay)) : "") + "&debug=" + encodeURIComponent(String(this._options.debug)) + (this._options.snapshot_url ? "&snapshotUrl=" + encodeURIComponent(this._options.snapshot_url) : "") + (this._options.timezone ? "&timezone=" + encodeURIComponent(this._options.timezone) : "") + (this._options.study_count_limit ? "&studyCountLimit=" + encodeURIComponent(String(this._options.study_count_limit)) : "") + (this._options.symbol_search_request_delay ? "&ssreqdelay=" + encodeURIComponent(String(this._options.symbol_search_request_delay)) : "") + (this._options.compare_symbols ? "&compareSymbols=" + encodeURIComponent(JSON.stringify(this._options.compare_symbols)) : "") + (this._options.theme ? "&theme=" + encodeURIComponent(String(this._options.theme)) : "") + (this._options.header_widget_buttons_mode ? "&header_widget_buttons_mode=" + encodeURIComponent(String(this._options.header_widget_buttons_mode)) : "") + (this._options.time_scale ? "&time_scale=" + encodeURIComponent(JSON.stringify(this._options.time_scale)) : "");
      return o.hash = r, "<iframe \n\t\t\tid=\"".concat(this._id, "\" name=\"").concat(this._id, "\" src=\"").concat(o.href, "\" data-widget-options=\"").concat(r, "\"\n\t\t\t").concat(this._options.autosize || this._options.fullscreen ? "" : "width=\"".concat(this._options.width, "\" height=\"").concat(this._options.height, "\""), " title=\"Financial Chart\" frameborder=\"0\" allowTransparency=\"true\" scrolling=\"no\" allowfullscreen style=\"display:block;\">\n\t\t</iframe>");
    }
  }]);

  return a;
}();

window.TradingView = window.TradingView || {}, window.TradingView.version = r;
export { r as version, a as widget };